
import { track } from '@/services/tracking'

export default {
  clearPhoneInput (module) {
    this.phone_number = ''
    this.sms_cleared = true
    this.sms_offers = false
    this.smsUpdates = false
    // Updating the component key to force re-render and clear the input field
    this.phoneInputKey += 1
    this.smsMessagesOptedOut = true

    track({
      name: 'button tap',
      params: {
        module: module,
        description: `clicked on I don’t want to receive text messages`
      }
    })
  },

  trackSmsOptionSelection (option, module) {
    track({
      name: 'button tap',
      params: {
        module: module,
        description: `SMS ${option} option selected`
      }
    })
  }
}
